import { render } from "./ArgonBadge.vue?vue&type=template&id=61b067ae"
import script from "./ArgonBadge.vue?vue&type=script&lang=js"
export * from "./ArgonBadge.vue?vue&type=script&lang=js"
script.render = render

export default script